import React from "react";
import ScreeningQuestionTwo from "../shared/ScreeningQuestionTwo";
import { handleStoreAlreadyDoneDetails } from "../public/CommonAPIHelper";

const AlreadyDoneQuestionTwoUI = () => {
  return (
    <ScreeningQuestionTwo
      questionText="Approximately when was your prior screening?"
      backRoute="./1"
      nextRoute="/alreadydone/3"
      onSubmitHandler={handleStoreAlreadyDoneDetails}
      showDayPicker={false}
    />
  );
};

export default AlreadyDoneQuestionTwoUI;
